<template>
    <div class="category-page page my-container">
        <h2 class="header">
            {{ group.name?.[locale] || group.name }}
        </h2>
        <div class="category-list">
            <NuxtLink
                :to="localePath(`/catalog/${route.params.type}/${route.params.id}/group/${route.params.group}/product/${product.id}`)"
                class="category" data-aos="fade-up" :data-aos-delay="100 * i" data-aos-once="true"
                v-for="(product, i) in catalog" :key="product.id">
                <div class="img-wrp">
                    <img :src="product.image" :alt="product.slug">
                </div>
                <span class="name">
                    {{ product.title[locale] }}
                </span>
            </NuxtLink>
        </div>
    </div>
</template>

<script setup>
const { locale, t } = useI18n()
const localePath = useLocalePath()
const rc = useRuntimeConfig();
const route = useRoute()
const res = await Promise.all([
    $fetch(rc.public.api + '/api/group/' + route.params.group),
    $fetch(rc.public.api + '/api/product/', {
        query: {
            [`filters[group_id]`]: route.params.group,
            [`filters[${route.params.type}_id]`]: route.params.id
        }
    })
])

const group = ref(res[0].data)
const catalog = ref(res[1].data.list)
</script>